/*
 * RIO1923 article behaviour (Fluorescent Stiletto port).
 * Replaces the bits of the Fluorescent theme.js used by main-article-rio and the
 * rio-* sections: social share popup, RTE iframe/table wrappers and the gallery carousel.
 */
(function () {
  if (window.rioArticle) return;

  const ROOT = '.rio-scope';

  /* ── RTE: wrap iframes (16:9) and tables (horizontal scroll) ── */
  function initRte(scope) {
    scope.querySelectorAll('.rte iframe').forEach(el => {
      if (el.parentElement.classList.contains('rte__iframe')) return;
      const wrapper = document.createElement('div');
      wrapper.classList.add('rte__iframe');
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
      el.src = el.src;
    });
    scope.querySelectorAll('.rte table').forEach(el => {
      if (el.parentElement.classList.contains('rte__table-wrapper')) return;
      const wrapper = document.createElement('div');
      wrapper.classList.add('rte__table-wrapper');
      wrapper.tabIndex = 0;
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    });
  }

  /* ── Social share popup ── */
  function initSocialShare(node) {
    const button = node.querySelector('.social-share__button');
    const popup = node.querySelector('.social-sharing__popup');
    const copyURLButton = node.querySelector('.social-share__copy-url');
    const successMessage = node.querySelector('.social-share__success-message');
    if (!button || !popup) return () => {};

    if (copyURLButton && !(navigator.clipboard && navigator.clipboard.writeText)) {
      copyURLButton.classList.add('hidden');
    }

    const close = () => {
      button.setAttribute('aria-expanded', false);
      popup.setAttribute('aria-hidden', true);
    };
    const open = () => {
      button.setAttribute('aria-expanded', true);
      popup.setAttribute('aria-hidden', false);
    };
    const showMessage = message => {
      successMessage.innerHTML = message;
      successMessage.classList.remove('hidden');
      popup.classList.add('social-sharing__popup--success');
      setTimeout(() => {
        successMessage.classList.add('hidden');
        popup.classList.remove('social-sharing__popup--success');
      }, 2000);
    };

    const handleClick = evt => {
      const buttonClicked = evt.target.closest('.social-share__button') === button;
      const popupClicked = evt.target.closest('.social-sharing__popup') === popup;
      const copyURLClicked = copyURLButton && evt.target.closest('.social-share__copy-url') === copyURLButton;
      const isActive = buttonClicked && button.getAttribute('aria-expanded') === 'true';

      if (!popupClicked) close();
      if (buttonClicked && !isActive) open();
      if (copyURLClicked) {
        const { url, successMessage: ok, errorMessage } = copyURLButton.dataset;
        navigator.clipboard.writeText(url).then(
          () => showMessage(ok),
          () => showMessage(errorMessage || 'Error copying link.')
        );
      }
    };

    window.addEventListener('click', handleClick);
    return () => {
      close();
      window.removeEventListener('click', handleClick);
    };
  }

  /* ── Gallery carousel (Swiper chunk) ── */
  function initGalleryCarousel(node) {
    const container = node.querySelector('.swiper');
    if (!container || !window.rioChunks) return () => {};

    const { loopCarousel, productsPerView, mobileProductsPerView } = node.dataset;
    // 1.05 factor gives a "peek" of the next slide, as in Fluorescent
    const perView = parseInt(productsPerView, 10) * 1.05;
    const mobilePerView = parseInt(mobileProductsPerView, 10) * 1.05;
    const nextEl = node.querySelector('[data-next]');
    const prevEl = node.querySelector('[data-prev]');

    let carousel;
    let destroyed = false;

    const handleOverflow = slides => {
      setTimeout(() => {
        const needsOverflow = container.querySelectorAll('.swiper-slide-visible').length !== slides.length;
        container.classList.toggle('has-overflow', needsOverflow);
      }, 0);
    };

    import(window.rioChunks.swiper).then(({ Swiper, Navigation }) => {
      if (destroyed) return;
      const options = {
        slidesPerView: mobilePerView,
        spaceBetween: 12,
        loop: loopCarousel === 'true',
        grabCursor: true,
        preloadImages: false,
        watchSlidesProgress: true,
        breakpoints: {
          720: { spaceBetween: 16, slidesPerView: perView },
          1200: { spaceBetween: 24, slidesPerView: perView }
        },
        on: {
          init() { handleOverflow(this.slides); },
          breakpoint() { handleOverflow(this.slides); }
        }
      };
      if (nextEl && prevEl) {
        options.modules = [Navigation];
        options.navigation = { nextEl, prevEl };
      }
      carousel = new Swiper(container, options);
    });

    return () => {
      destroyed = true;
      if (carousel) carousel.destroy();
    };
  }

  /* ── Lifecycle ── */
  const cleanups = new Map();

  function init(section) {
    if (cleanups.has(section)) return;
    const fns = [];
    initRte(section);
    section.querySelectorAll('.social-share').forEach(node => fns.push(initSocialShare(node)));
    section.querySelectorAll('[data-rio-gallery-carousel]').forEach(node => fns.push(initGalleryCarousel(node)));
    cleanups.set(section, () => fns.forEach(fn => fn()));
  }

  function destroy(section) {
    const fn = cleanups.get(section);
    if (fn) fn();
    cleanups.delete(section);
  }

  function initAll() {
    document.querySelectorAll(ROOT).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme editor */
  document.addEventListener('shopify:section:load', e => {
    if (e.target.matches(ROOT)) init(e.target);
  });
  document.addEventListener('shopify:section:unload', e => {
    if (e.target.matches(ROOT)) destroy(e.target);
  });

  window.rioArticle = { init, destroy };
})();
